import { ReactNode } from 'react';

import { Box, Stack, Typography } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

import Person, { PersonProps } from './Person';
import ContractStaffIndicator from 'src/assets/images/indicator-icons/contract-staff-indicator.svg?react';

export interface TeamMemberProps extends PersonProps {
    isAgencyStaff?: boolean;
    jobTitle?: string;
    children?: ReactNode;
    containerSx?: SxProps<Theme>;
}

function TeamMember(props: TeamMemberProps) {
    const { isAgencyStaff = false, jobTitle = '', children, containerSx, ...personProps } = props;
    const { firstName, lastName } = personProps;

    return (
        <Stack
            direction="row"
            sx={[
                { alignItems: 'center', gap: 1 },
                ...(containerSx ? (Array.isArray(containerSx) ? containerSx : [containerSx]) : []),
            ]}
        >
            <Person {...personProps} />
            <Box sx={{ width: '100%' }}>
                <Typography
                    variant="body1"
                    component="h4"
                    sx={{
                        fontWeight: 'bold',
                        color: 'grey.900',
                    }}
                >
                    {firstName} {lastName}
                </Typography>
                {(isAgencyStaff || jobTitle) && (
                    <Stack direction="row" sx={{ gap: 0.5 }}>
                        {isAgencyStaff && (
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <ContractStaffIndicator />
                            </Box>
                        )}
                        {jobTitle && (
                            <Typography
                                variant="subtitle1"
                                component="p"
                                sx={{
                                    color: 'grey.900',
                                }}
                            >
                                {jobTitle}
                            </Typography>
                        )}
                    </Stack>
                )}
                {children}
            </Box>
        </Stack>
    );
}

export default TeamMember;
